<app-table-header
  (reload)="onRefreshList(false)"
  [loading]="loading"
  [withExportOption]="!!data.info.exportTableName"
  (exportBtnClicked)="exportBtnClicked()"
  >
  <div style="margin-right: auto; width: 500px">
    <nz-form-item nz-col [nzSpan]="12" class="center">
      <label
        nz-checkbox
        [(ngModel)]="showArticlesBelowMinStock"
        (ngModelChange)="onRefreshList()"
      >Produkte, die unter dem Mindestbestand liegen</label>
    </nz-form-item>
    <div class="full-width">
      <label for="lastSupplier">letzter Lieferant</label>
      <nz-select
        class="full-width"
        nzPlaceHolder="Wählen Sie letzter Lieferant"
        nzShowSearch
        nzServerSearch
        (nzOnSearch)="onSearchSupplier($event)"
        [compareWith]="compareSimpleList"
        nzMode="multiple"
        [(ngModel)]="selectedLastSuppliers"
        (ngModelChange)="onRefreshList()"
        id="lastSupplier"
        >
        @for (o of suppliersList; track o) {
          @if (!isSuppliersLoading) {
            <nz-option [nzValue]="o" [nzLabel]="o.value"></nz-option>
          }
        }
        @if (isSuppliersLoading) {
          <nz-option nzDisabled nzCustomContent>
            <i nz-icon nzType="loading" class="loading-icon"></i> Daten laden...
          </nz-option>
        }
      </nz-select>
    </div>
  </div>
  <app-table-search-bar (search)="search($event)" [searchValue]="currentSearch"></app-table-search-bar>
</app-table-header>


<div class="grouped-table-hscroll">
<nz-table appColumnLayout
  #tableRef
  [nzScroll]="{ x: tableMaxWidth }"
  nzShowSizeChanger
  [nzData]="data.results"
  [nzLoading]="loading"
  [nzTotal]="data.info.totalResults"
  [nzFrontPagination]="false"
  [nzPageSize]="pageSize"
  [nzPageIndex]="data.info.page"
  (nzQueryParams)="onQueryParamsChange($event)"
  appKeepState
  id="articles-list-table"
  >
  <thead>
    <tr>
      <th nzColumnKey="article.orderNumber" [nzSortFn]="true" nzWidth="120px">Nummer</th>
      <th nzColumnKey="productionArticle.name" [nzSortFn]="true">Name</th>
      <th nzColumnKey="bulkContainerState" [nzSortFn]="true">Bestand</th>
      <th nzColumnKey="difference" [nzSortFn]="true">In Produktion</th>
      <th nzColumnKey="minStock" [nzSortFn]="true">Mindest-<br>bestand</th>
      <th nzColumnKey="supplier.name" [nzSortFn]="true">Lieferant</th>
      <th nzColumnKey="separator" class="separator-box" nzWidth="44px"></th>
      <th nzColumnKey="orderDate" [nzSortFn]="true">Bestelltermin</th>
      <th nzColumnKey="orderSupplier.name" [nzSortFn]="true">Lieferant</th>
      <th nzColumnKey="orderQuantitySum" [nzSortFn]="true">Menge</th>
      <th nzColumnKey="separator-2" class="separator-box" nzWidth="27px"></th>
      <th nzColumnKey="actions" nzWidth="73px"></th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td colspan="6" style="text-align: center">Artikel</td>
      <td class="separator-box">
        <div class="separator"></div>
      </td>
      <td colspan="3" style="text-align: center; padding-right: 60px;" class="next-deliver">Nächste Lieferung</td>
      <td class="separator-box">
        <div class="separator"></div>
      </td>
      <td></td>
    </tr>
    @for (val of data.results; track val) {
      <tr>
        <td class="cell-nowrap">{{ val.article?.orderNumber || '–' }}</td>
        <td>{{ val.productionArticle.name }}</td>
        <td>{{ val.bulkContainerState | productionUnit:true }}</td>
        <td>{{ val.difference | productionUnit:true }}</td>
        <td>{{ val.minStock !== null ? (val.minStock | productionUnit:true) : '' }}</td>
        <td>
          <a [routerLink]="['/suppliers']" [queryParams]="{search: val.supplier?.name}">{{val.supplier?.name}}</a>
          @if (val.supplier?.contactPerson || val.supplier?.phoneNumber || val.supplier?.email || val.supplier?.comment || val.supplier?.address) {
            <i nz-icon nzType="info-circle" nzTheme="outline"
              nz-tooltip
              [nzTooltipTitle]="val.supplier | supplierTooltip"
            style="margin-left: 4px; cursor: help;"></i>
          }
        </td>
        <td class="separator-box">
          <div class="separator"></div>
        </td>
        <td class="next-deliver">{{ val.orderDate | dateFormat }}</td>
        <td class="next-deliver">{{ val.orderSupplier?.name }}</td>
        <td class="next-deliver">
          {{ val.orderQuantitySum ? (val.orderQuantitySum | productionUnit:true) : 'Keine weitere Lieferung geplant' }}
        </td>
        <td class="separator-box">
          <div class="separator"></div>
        </td>
        <td>
          <div class="actions">
            <span>
              <a
                routerLink="/bulk-containers/bulk-container/{{ val.productionArticle.id }}"
                [queryParams]="{ 'tab': 'deliveries'}"
                >
                <i
                  nz-icon
                  nzType="edit"
                  nzTheme="outline"
                  nz-tooltip
                  nzTooltipTitle="Bearbeiten Großgebinde"
                ></i>
              </a>
            </span>
          </div>
        </td>
      </tr>
    }
  </tbody>
</nz-table>
</div>

<app-export-table-modal #exportTableModalComponent></app-export-table-modal>
